import { uid } from '../../../../lib/uid';

const KINDS = [
  'Certificate of Live Birth',
  'Certificate of Marriage',
  'Diploma',
  'Training certificate',
  'Appointment',
  'Notice of Salary Adjustment',
  'Clearance',
];

/**
 * A sample checklist row, so the create form fills in one click.
 *
 * The name is suffixed because it is unique among active rows: Autogenerate is most useful
 * clicked repeatedly, and without a suffix the second click produces a name the server rejects
 * as a duplicate.
 *
 * Obviously disposable rather than a real organization's list — these rows decide what every
 * 201 file is asked for, so a generated one must be easy to tell from a real one.
 */
export function samplePersonnelDocumentType(): {
  name: string;
  description: string;
} {
  const tag = uid().slice(0, 4).toUpperCase();
  const kind = KINDS[Math.floor(Math.random() * KINDS.length)];

  return {
    name: `${kind} ${tag}`,
    description: `Sample checklist row ${tag}. Delete it once the real list is in.`,
  };
}
